var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNlReports(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321.46,275s-3.32,7.15-3.58,8.69,1.28,3.57,1.28,4.34-2,3.06-2,6.64-.26,11.75,2.81,13.79,8.17-.25,8.17-.25l4.85,9.45,19.41-11.24-2.81-4.34s4.09-11,1-19.41-14-9.71-18.39-10S323,271.91,321.46,275Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.12,320.69s-5.62,7.66-7.66,11.49-10.73,26.31-14.56,34.23a76,76,0,0,0-5.3,14.22h53.57s6.13-30.57,6.13-43.85-3.06-23.24-4.09-25.79-4.85-4.6-4.85-4.6Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389.4,290.31s-17.64-3.53-22.58.7-2.12,30-3.53,36.7-4.94,13.76-3.53,20.81,4.59,12,6,15.53-.36,16.58-.36,16.58h51.52s9.17-24.34,9.17-42.69-5.65-34.22-14.11-40.22S389.4,290.31,389.4,290.31Z",
    style: {
      fill: "#FF725E",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-4--inject-24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M387.28,318.86s.35,53.3-1.06,57.54-6.35,4.23-14.46,4.58-57.51-1.05-57.51-1.05a66.64,66.64,0,0,1-8.47.7c-3.88,0-10.59-.7-13.06-2.47s-4.58-2.12-5.64-1.76-3.88,3.88-6.35,3.88-5.3-1.06-3.53-1.41,11.29-10.59,13.41-10.59,17.28,3.88,20.11,3.53S364,361.58,364,361.58l-1.76-55s-1.77-9.53,7.06-13.06",
    style: {
      fill: "#FF725E",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-5--inject-24"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 124.22,
    y: 203.98,
    width: 164.61,
    height: 176.73,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-6--inject-24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193,329.33s-4.68,7.1-2.71,10.55,9.12,10.59,23.89,9.6,5.91-25.85,7.63-41.12-4.67-17.48-9.85-13.54-11.57,22.9-14,26.1A57,57,0,0,0,193,329.33Z",
    style: {
      fill: "#FF725E",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-7--inject-24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.23,295.55s-.25,28.32,0,32.76-2,5.91,1.72,6.65,33.74,1.47,36.69,1,3-2,3.7-3.45,10.58-64.76,8.37-66.49-16.25-6.89-17.49-6.89-19.45,1-22.9,1.48-7.39-.5-7.63,1.47S211.23,295.55,211.23,295.55Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-8--inject-24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.1,258.94s-14.77-1.27-17.77-.61-10,17.67-11,20-12,13-12,13L159.67,279l-3.34,9.33S182,305,186.33,307s10.34,1.67,12.34,1.67a7.48,7.48,0,0,0,4-1.67L193,329.33s15.67-18.66,20.33-27.66,15.34-35.34,16.34-36S232.1,258.94,232.1,258.94Z",
    style: {
      fill: "#FF725E",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-9--inject-24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.32,221s-4.42,6.8-4.14,8.22,1,2.87,1,4-5,5.11-4.42,6,3.41,2.27,3.41,2.27-.12,11.09,2.43,12.51,7.4-.86,7.4-.86l2.55,14.22,14.5-10.24V246.89s8.53-9.66,9.1-17.34-10-16.2-20.47-17.62-16.2,5.68-14.5,8S224.32,221,224.32,221Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-10--inject-24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.93,259.35s-3.2,11.33-7.14,25.62-3.2,58.6-3.2,61.07,5.66,11.32,12.07,13.79a51.89,51.89,0,0,0,13,2.95s-4.43-29.3-4.43-37.67,3.94-21.43,3.94-21.43,5.91,14.78,8.37,16.75,12.31,4.18,12.07-4.93-8.62-41.62-10.84-44.82-12.81-6.4-12.81-6.4Z",
    style: {
      fill: "#FF725E",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-11--inject-24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.12,320.92s-9.36-4.19-10.1-4.19-8.12,3.94-9.6,3.94-2.22,1-1.23,1.73a5.34,5.34,0,0,0,2.71.74s-3.45,2-3.21,2.95,2.22,1.72,2.22,1.72a9.06,9.06,0,0,0,4.19,3.45c2.46.74,11.08-2.21,11.08-2.21l6.65-.5Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-12--inject-24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.53,310.33l-23.15,9.36,1.72,9.85s31-4.43,32.51-6.65-4.19-14.78-4.19-14.78",
    style: {
      fill: "#FF725E",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.28,133.88s-42.61-47.57-108.6-44-121.42,51.42-167.3,88.94S48,273.52,76,317.47s70.69,24.42,126.14,52.25,66.19,44,127.23,35.84,106.27-80.78,97.88-157.08S381.28,133.88,381.28,133.88Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.28,133.88s-42.61-47.57-108.6-44-121.42,51.42-167.3,88.94S48,273.52,76,317.47s70.69,24.42,126.14,52.25,66.19,44,127.23,35.84,106.27-80.78,97.88-157.08S381.28,133.88,381.28,133.88Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Windows--inject-24"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.67,
    y: 146.33,
    width: 274,
    height: 178,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.67,
    y: 146.33,
    width: 274,
    height: 178,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.76,
    y: 207.78,
    width: 155.8,
    height: 98.65,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.57,196.31l-3-8.64H176.73V313.61H338.59V196.31Zm107,110.12H179.76V207.78h155.8Z",
    style: {
      fill: "#FF725E",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.55,
    y: 199.58,
    width: 77.4,
    height: 4.74,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "183.51 198.82 181.28 200.97 183.59 203.45",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 181.28,
    y1: 200.97,
    x2: 186.24,
    y2: 200.97,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "196.16 198.82 198.4 200.97 196.08 203.45",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 198.4,
    y1: 200.97,
    x2: 193.44,
    y2: 200.97,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.06,200.68a2.44,2.44,0,0,0-2.27-1.78,2.24,2.24,0,1,0,0,4.47,2.19,2.19,0,0,0,1.41-.51",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "207.56 200.93 209.29 200.93 209.29 198.87",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220.89 200.2 218.83 198.53 216.87 200.2 216.87 203.83 220.89 203.83 220.89 200.2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.05,
    y: 201.18,
    width: 1.57,
    height: 2.52,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 216.87,
    y1: 200.2,
    x2: 215.69,
    y2: 201.28,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220.89,
    y1: 200.2,
    x2: 222,
    y2: 201.18,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220.15,
    y1: 192.14,
    x2: 223.29,
    y2: 195.38,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 223.34,
    y1: 192.19,
    x2: 220.1,
    y2: 195.33,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 327.35,
    y1: 200.45,
    x2: 333.56,
    y2: 200.45,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 327.35,
    y1: 201.85,
    x2: 333.56,
    y2: 201.85,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 327.35,
    y1: 203.24,
    x2: 333.56,
    y2: 203.24,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 327.35,
    y1: 204.64,
    x2: 333.56,
    y2: 204.64,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 294.77,
    y1: 219.42,
    x2: 302.59,
    y2: 219.42,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 284.65,
    y1: 219.42,
    x2: 291.51,
    y2: 219.42,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 267.82,
    y1: 219.42,
    x2: 282.11,
    y2: 219.42,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 267.82,
    y1: 224.2,
    x2: 302.59,
    y2: 224.2,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 297.48,
    y1: 228.97,
    x2: 302.59,
    y2: 228.97,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 273.44,
    y1: 228.97,
    x2: 294.22,
    y2: 228.97,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 267.82,
    y1: 228.97,
    x2: 270.55,
    y2: 228.97,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 267.82,
    y1: 233.74,
    x2: 302.59,
    y2: 233.74,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.21,
    y: 273.56,
    width: 7.73,
    height: 23.75,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.26,
    y: 245.39,
    width: 7.73,
    height: 51.93,
    style: {
      fill: "#FF725E",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.31,
    y: 260.86,
    width: 7.73,
    height: 36.46,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.35,
    y: 245.39,
    width: 7.73,
    height: 51.93,
    style: {
      fill: "#FF725E",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.4,
    y: 222.74,
    width: 7.73,
    height: 74.58,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.95,
    y: 177.77,
    width: 155.8,
    height: 98.65,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.75,166.31l-3-8.65H88.92V283.6H250.77V166.31Zm107,110.11H92V177.77h155.8Z",
    style: {
      fill: "#FF725E",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.73,
    y: 169.57,
    width: 77.4,
    height: 4.74,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "95.7 168.81 93.46 170.97 95.78 173.45",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 93.46,
    y1: 170.97,
    x2: 98.43,
    y2: 170.97,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "108.35 168.81 110.58 170.97 108.27 173.45",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 110.59,
    y1: 170.97,
    x2: 105.62,
    y2: 170.97,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.25,170.68A2.43,2.43,0,0,0,119,168.9a2.23,2.23,0,1,0,0,4.46,2.27,2.27,0,0,0,1.42-.5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "119.74 170.93 121.48 170.93 121.48 168.86",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.08 170.19 131.02 168.53 129.06 170.19 129.06 173.82 133.08 173.82 133.08 170.19",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.23,
    y: 171.17,
    width: 1.57,
    height: 2.52,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129.06,
    y1: 170.19,
    x2: 127.88,
    y2: 171.27,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 133.08,
    y1: 170.19,
    x2: 134.19,
    y2: 171.18,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 132.34,
    y1: 162.14,
    x2: 135.47,
    y2: 165.37,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 135.52,
    y1: 162.19,
    x2: 132.29,
    y2: 165.32,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 239.54,
    y1: 170.44,
    x2: 245.75,
    y2: 170.44,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 239.54,
    y1: 171.84,
    x2: 245.75,
    y2: 171.84,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 239.54,
    y1: 173.24,
    x2: 245.75,
    y2: 173.24,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 239.54,
    y1: 174.64,
    x2: 245.75,
    y2: 174.64,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.96 266.9 99.96 232.83 110.8 255.78 120.01 251.76 130.43 259.99 148.18 248.45 159.02 263.59 166.61 259.81 173.11 263.59 181.24 262.64 192.07 265.25 203.45 264.3 210.69 266.9 99.96 266.9",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 214.06,
    y1: 207.78,
    x2: 225.87,
    y2: 207.78,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 198.77,
    y1: 207.78,
    x2: 209.14,
    y2: 207.78,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 173.35,
    y1: 207.78,
    x2: 194.95,
    y2: 207.78,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 173.35,
    y1: 212.55,
    x2: 225.87,
    y2: 212.55,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 218.15,
    y1: 217.33,
    x2: 225.87,
    y2: 217.33,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 181.84,
    y1: 217.33,
    x2: 213.24,
    y2: 217.33,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 173.35,
    y1: 217.33,
    x2: 177.47,
    y2: 217.33,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 173.35,
    y1: 222.1,
    x2: 225.87,
    y2: 222.1,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 225.87,
    y1: 229.78,
    x2: 214.06,
    y2: 229.78,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 198.77,
    y1: 229.78,
    x2: 209.14,
    y2: 229.78,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 173.35,
    y1: 229.78,
    x2: 194.95,
    y2: 229.78,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 173.35,
    y1: 234.55,
    x2: 225.87,
    y2: 234.55,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 225.87,
    y1: 239.33,
    x2: 218.15,
    y2: 239.33,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 181.84,
    y1: 239.33,
    x2: 213.24,
    y2: 239.33,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 173.35,
    y1: 239.33,
    x2: 177.47,
    y2: 239.33,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 173.35,
    y1: 244.1,
    x2: 225.87,
    y2: 244.1,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.43,215.64l-6.21,14a15.27,15.27,0,0,1-7.74-20.16,15.08,15.08,0,0,1,14-9.05Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.47000000000000003
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.43,215.64l-6.21,14a15.27,15.27,0,0,1-7.74-20.16,15.08,15.08,0,0,1,14-9.05Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M113.43,215.64l7.17,13.49a14.85,14.85,0,0,1-13.38.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.43,215.64,125.3,206A15.26,15.26,0,0,1,123,227.51a14.76,14.76,0,0,1-2.44,1.62Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.43,215.64V200.38A14.58,14.58,0,0,1,125.3,206Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.43,
    cy: 215.67,
    r: 8.31,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.81,215.64l-6.21,14a15.26,15.26,0,0,1-7.74-20.16,15.07,15.07,0,0,1,13.95-9.05Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.47000000000000003
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.81,215.64l-6.21,14a15.26,15.26,0,0,1-7.74-20.16,15.07,15.07,0,0,1,13.95-9.05Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M154.81,215.64,162,229.13a14.85,14.85,0,0,1-13.38.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.81,215.64l11.86-9.6A15.28,15.28,0,0,1,162,229.13Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.81,215.64V200.38A14.56,14.56,0,0,1,166.67,206Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.81,
    cy: 215.67,
    r: 8.31,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 99.42,
    y1: 188.53,
    x2: 197.52,
    y2: 188.53,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 99.42,
    y1: 193.31,
    x2: 215.75,
    y2: 193.31,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.9,287s-4.85,5.62-4.34,6.64,4.6,3.57,4.85,2a63.63,63.63,0,0,0,1-7.41C320.44,286.47,320.69,286,318.9,287Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.46,275s-3.32,7.15-3.58,8.69,1.28,3.57,1.28,4.34-2,3.06-2,6.64-.26,11.75,2.81,13.79,8.17-.25,8.17-.25l4.85,9.45,19.41-11.24-2.81-4.34s4.09-11,1-19.41-14-9.71-18.39-10S323,271.91,321.46,275Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-24)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M349.55,302.05s4.09-11,1-19.41-14-9.71-18.39-10c-.71,0-1.44-.09-2.17-.12L324.33,277s-4.66,6.67-2.66,9.33,3.33,5.34,2.66,9.67-5.09,11.82-.66,12c.91,0,2.35.16,4.06.33l.37-.15.1.2c6.54.66,16.47,1.95,16.47,1.95l1-.05,6.71-3.89Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.55,302.05s4.09-11,1-19.41-14-9.71-18.39-10c-.71,0-1.44-.09-2.17-.12L324.33,277s-4.66,6.67-2.66,9.33,3.33,5.34,2.66,9.67-5.09,11.82-.66,12c.91,0,2.35.16,4.06.33l.37-.15.1.2c6.54.66,16.47,1.95,16.47,1.95l1-.05,6.71-3.89Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M321.46,275s-3.32,7.15-3.58,8.69,1.28,3.57,1.28,4.34-2,3.06-2,6.64-.26,11.75,2.81,13.79,8.17-.25,8.17-.25l4.85,9.45,19.41-11.24-2.81-4.34s4.09-11,1-19.41-14-9.71-18.39-10S323,271.91,321.46,275Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348,267.06s-9.45-2.81-17.62-2.56-16.35,2.56-16.09,6.9,7.91,5.87,7.91,5.87,4.35.26,3.07,1.53-4.6,3.84-2,6.9,5.1,5.62,4.34,6.64.25,3.32,1.27,2.56-.51-3.84,2.3-4.86,5.62,3.32,4.6,6.13-2.81,2.56-1.79,4.6,7.41,5.36,11.75,5.36,5.62-5.62,10.22-14.56S357.47,269.61,348,267.06Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.76,319.93l2.55,4.85,28.1-18.39-2.81-3.32S328.1,316.09,323.76,319.93Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.12,320.69s-5.62,7.66-7.66,11.49-10.73,26.31-14.56,34.23a76,76,0,0,0-5.3,14.22h53.57s6.13-30.57,6.13-43.85-3.06-23.24-4.09-25.79-4.85-4.6-4.85-4.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-24)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.12,320.69s-5.62,7.66-7.66,11.49-10.73,26.31-14.56,34.23a76,76,0,0,0-5.3,14.22h53.57s6.13-30.57,6.13-43.85-3.06-23.24-4.09-25.79-4.85-4.6-4.85-4.6Z",
    style: {
      fill: "#bdbdbd",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.43,349.42s12-18.79,16.52-23.65,26.94-16.36,26.94-16.36l-3.54-3.84s-23.07,11.45-26.64,15S313.79,345.2,314.43,349.42Z",
    style: {
      fill: "#bdbdbd",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M329.12,320.69s-5.62,7.66-7.66,11.49-10.73,26.31-14.56,34.23a76,76,0,0,0-5.3,14.22h53.57s6.13-30.57,6.13-43.85-3.06-23.24-4.09-25.79-4.85-4.6-4.85-4.6Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.93,320.69s-14,9.2-16.09,12.77-.25,9.2-.25,10-2,3.32-2,4.09v2.55l-11,29.63h25s10.73-26.05,12.77-31.16,3.07-14.3,2.05-19.41",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.89,342.66s6.13-7.16,15.32-8.18",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389.4,290.31s-17.64-3.53-22.58.7-2.12,30-3.53,36.7-4.94,13.76-3.53,20.81,4.59,12,6,15.53-.36,16.58-.36,16.58h51.52s9.17-24.34,9.17-42.69-5.65-34.22-14.11-40.22S389.4,290.31,389.4,290.31Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-3--inject-24)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370.51,301.33c-5,8.34.67,54,2,58.34s-8.33.33-5.33,2.66,8.66,6.34,8.66,6.34A104.2,104.2,0,0,0,366,365a19.5,19.5,0,0,1,.27,3.16,94.68,94.68,0,0,0,10.54,7.15l-10.95.92c-.23,2.51-.49,4.38-.49,4.38h51.52s9.17-24.34,9.17-42.69a77.89,77.89,0,0,0-3.17-22.58l-30.74-13S375.51,293,370.51,301.33Z",
    style: {
      opacity: 0.26
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M389.4,290.31s-17.64-3.53-22.58.7-2.12,30-3.53,36.7-4.94,13.76-3.53,20.81,4.59,12,6,15.53-.36,16.58-.36,16.58h51.52s9.17-24.34,9.17-42.69-5.65-34.22-14.11-40.22S389.4,290.31,389.4,290.31Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389,226.8s-7.76-6.35-15.17-1.76-20.11,25.75-18.7,36.34,14.12,20.46,5.65,26.11-5.29,15.87-1.06,18.7l2.47.35s0-10.23,7.06-13.06,17.28-.35,19.75,2.83-2.11,19.4,3.88,23.64,14.47,4.94,12.71,9.17-7.77,10.94-3.89,16.94,13.41,12,16.59,9.87-1.41-4.58.35-6,16.23-6.35,13.76-12.35-7.76-9.18-5.29-11.65,11.64-8.46,10.58-16.93-21.17-14.82-21.87-24,12-10.23,7.76-31S406.33,224,400,224A22.78,22.78,0,0,0,389,226.8Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.86,237.87c5.32,7.38,12,18.25,12.23,26.47.33,13.69-11.69,19.37-9.69,30.05s25.35,12.52,27.05,22-9,6-6.35,11.35,13,10,8.69,16",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.39,229.62s1.12,1.28,2.81,3.42",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.1,283.74c1.22,1.28,1.95,2.47,1.95,3.64",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.68,243s-5.34,14.69,2.67,24.71c4.27,5.34,9.58,9.25,13.61,12.45",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.77,303.87c1.55.56,3.24,1,5,1.54",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.76,240s11.35,14.36,7.35,26.71-17.36,19-17.36,27a9.46,9.46,0,0,0,2.27,6.7",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.86,368.87s-2.12,2.61-2.12,4.24-.81,4.88.17,5.05,1.62-3.43,2.6-4.73,3.42-1.63,3.26-3.42S280.33,366.59,278.86,368.87Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.33,371.15s-9.13-7.66-11.41-8.47-6.85,4.4-9.62,9.45-1.3,6.19.17,6.35,7.82-2.6,7.82-2.6a19.75,19.75,0,0,0,7.66,3.74c4.4,1,10.75-1.63,10.92-4.23S302.33,371.15,302.33,371.15Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.28,318.86s.35,53.3-1.06,57.54-6.35,4.23-14.46,4.58-57.51-1.05-57.51-1.05a66.64,66.64,0,0,1-8.47.7c-3.88,0-10.59-.7-13.06-2.47s-4.58-2.12-5.64-1.76-3.88,3.88-6.35,3.88-5.3-1.06-3.53-1.41,11.29-10.59,13.41-10.59,17.28,3.88,20.11,3.53S364,361.58,364,361.58l-1.76-55s-1.77-9.53,7.06-13.06",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-4--inject-24)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M373.22,298.81a6.6,6.6,0,0,0-2.71,2.52c-5,8.34.67,54,2,58.34s-8.33.33-5.33,2.66,8.66,6.34,8.66,6.34-16.33-7-12-2.67,13,9.33,13,9.33l-57,4.75c13.18.36,45.46,1.18,51.89.9,8.11-.35,13.05-.35,14.46-4.58s1.06-58.57,1.06-58.57Z",
    style: {
      opacity: 0.26
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M387.28,318.86s.35,53.3-1.06,57.54-6.35,4.23-14.46,4.58-57.51-1.05-57.51-1.05a66.64,66.64,0,0,1-8.47.7c-3.88,0-10.59-.7-13.06-2.47s-4.58-2.12-5.64-1.76-3.88,3.88-6.35,3.88-5.3-1.06-3.53-1.41,11.29-10.59,13.41-10.59,17.28,3.88,20.11,3.53S364,361.58,364,361.58l-1.76-55s-1.77-9.53,7.06-13.06",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.94,380.32a19,19,0,0,1,.69-12.06c-9.64,1.86-17.82,3.41-18.91,3.55-2.83.35-18-3.53-20.11-3.53S279,378.51,277.2,378.87s1.06,1.41,3.53,1.41,5.29-3.53,6.35-3.88,3.17,0,5.64,1.76,9.18,2.47,13.06,2.47a66.64,66.64,0,0,0,8.47-.7Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.61,365.12a10.7,10.7,0,0,0-3.75,3.75c-1,2.12,0,8.63,1.63,8.63s2.77-1.79,2.77-4.07S282.61,365.12,282.61,365.12Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.89,363.82s-2.61.16-3.59,2.12-.81,10.26.82,10.59,2.28-2.45,2.28-4.24S284.89,363.82,284.89,363.82Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.92,362.68s-3.91-.66-5.54.49-2,11.24-.82,12.05,3.1-1.3,3.1-2.44,2.28-7.33,2.28-7.33",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-24"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-5--inject-24)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193,329.33s-4.68,7.1-2.71,10.55,9.12,10.59,23.89,9.6,5.91-25.85,7.63-41.12-4.67-17.48-9.85-13.54-11.57,22.9-14,26.1A57,57,0,0,0,193,329.33Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-6--inject-24)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193,329.33s-4.68,7.1-2.71,10.55,9.12,10.59,23.89,9.6,5.91-25.85,7.63-41.12-4.67-17.48-9.85-13.54-11.57,22.9-14,26.1A57,57,0,0,0,193,329.33Z",
    style: {
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.42
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M193,329.33s-4.68,7.1-2.71,10.55,9.12,10.59,23.89,9.6,5.91-25.85,7.63-41.12-4.67-17.48-9.85-13.54-11.57,22.9-14,26.1A57,57,0,0,0,193,329.33Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211,333.48s0,21.91.25,28.81,1.23,23.64,1.23,23.64h46.29l-2.46-50-.74-2.46Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.91 339.28 256.49 340.03 256.29 335.94 255.55 333.48 237.62 333.48 237.91 339.28",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.9,333.48H211s0,1.89,0,4.73l4.91.19Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "217.47 333.48 217.75 338.48 234.57 339.15 234.4 333.48 217.47 333.48",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.23,295.55s-.25,28.32,0,32.76-2,5.91,1.72,6.65,33.74,1.47,36.69,1,3-2,3.7-3.45,10.58-64.76,8.37-66.49-16.25-6.89-17.49-6.89-19.45,1-22.9,1.48-7.39-.5-7.63,1.47S211.23,295.55,211.23,295.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-7--inject-24)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.32,268.51s-5.77-.28-6.87.27c-.62.31-4.4,9.59-7.57,17.59-.37,5.21-.65,9.18-.65,9.18s-.25,28.32,0,32.76c.16,2.91-.73,4.54-.33,5.53,1.25-4.34,3.24-11.83,5.53-22.48C220.28,293.5,226.32,268.51,226.32,268.51Z",
    style: {
      fill: "#bdbdbd"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M211.23,295.55s-.25,28.32,0,32.76-2,5.91,1.72,6.65,33.74,1.47,36.69,1,3-2,3.7-3.45,10.58-64.76,8.37-66.49-16.25-6.89-17.49-6.89-19.45,1-22.9,1.48-7.39-.5-7.63,1.47S211.23,295.55,211.23,295.55Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,280s-8.86-4.43-12.06-5.17-13.55-3.2-14.29-2.22.25,2,1.24,2,7.38,2.71,7.38,2.71-.73,5.91-.73,7.39,7.88,4.43,9.6,4.68,5.19-1.07,5.19-1.07l2.44-.66Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.54,278.32s-1,6.65-.25,7.38,5.91,4.19,6.65,2.47.49-8.38.49-9.11S141.54,278.32,141.54,278.32Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.05,280.29s-8.37-3.2-10.34-3.2-5.17,2.7-6.9,3.2.49,2,1.73,1.72,4.67-1.23,4.67-1.23a10.54,10.54,0,0,0,3.21,3.69c2,1.23,6.15.5,6.15.5",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.1,258.94s-14.77-1.27-17.77-.61-10,17.67-11,20-12,13-12,13L159.67,279l-3.34,9.33S182,305,186.33,307s10.34,1.67,12.34,1.67a7.48,7.48,0,0,0,4-1.67L193,329.33s15.67-18.66,20.33-27.66,15.34-35.34,16.34-36S232.1,258.94,232.1,258.94Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-8--inject-24)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.91,297.63c-.8,0-1.87-.53-2.94-.53s1.34,4,.8,5.36-38.84-15-38.84-15l-.07,1.21c3.62,2.35,25.5,16.5,29.47,18.33,4.34,2,10.34,1.67,12.34,1.67a6.87,6.87,0,0,0,3.61-1.38c2.92-7.45,5-19.83,5-19.83S198.72,297.63,197.91,297.63Z",
    style: {
      opacity: 0.26
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M232.1,258.94s-14.77-1.27-17.77-.61-10,17.67-11,20-12,13-12,13L159.67,279l-3.34,9.33S182,305,186.33,307s10.34,1.67,12.34,1.67a7.48,7.48,0,0,0,4-1.67L193,329.33s15.67-18.66,20.33-27.66,15.34-35.34,16.34-36S232.1,258.94,232.1,258.94Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "232.1 258.94 228 262.83 228.21 270.61 232.53 266.5 232.1 258.94",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.32,221s-4.42,6.8-4.14,8.22,1,2.87,1,4-5,5.11-4.42,6,3.41,2.27,3.41,2.27-.12,11.09,2.43,12.51,7.4-.86,7.4-.86l2.55,14.22,14.5-10.24V246.89s8.53-9.66,9.1-17.34-10-16.2-20.47-17.62-16.2,5.68-14.5,8S224.32,221,224.32,221Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-9--inject-24)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.65,260.94l5.41-3.82V246.89s8.53-9.66,9.1-17.34c.37-5-4-10.39-10-13.92l-15.08,6.25s-7.08,6.22-6.15,7.06,3.65,4.32,3,5.92c0,0-2.53,1-2.27,2.73s6.15,13,6.15,13L230,253.14Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.65,260.94l5.41-3.82V246.89s8.53-9.66,9.1-17.34c.37-5-4-10.39-10-13.92l-15.08,6.25s-7.08,6.22-6.15,7.06,3.65,4.32,3,5.92c0,0-2.53,1-2.27,2.73s6.15,13,6.15,13L230,253.14Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M224.32,221s-4.42,6.8-4.14,8.22,1,2.87,1,4-5,5.11-4.42,6,3.41,2.27,3.41,2.27-.12,11.09,2.43,12.51,7.4-.86,7.4-.86l2.55,14.22,14.5-10.24V246.89s8.53-9.66,9.1-17.34-10-16.2-20.47-17.62-16.2,5.68-14.5,8S224.32,221,224.32,221Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.93,259.35s-3.2,11.33-7.14,25.62-3.2,58.6-3.2,61.07,5.66,11.32,12.07,13.79a51.89,51.89,0,0,0,13,2.95s-4.43-29.3-4.43-37.67,3.94-21.43,3.94-21.43,5.91,14.78,8.37,16.75,12.31,4.18,12.07-4.93-8.62-41.62-10.84-44.82-12.81-6.4-12.81-6.4Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-10--inject-24)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.26
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M257.28,325.11v0c-5.6,1.45-10.08,2.49-10.08,2.49s6.86,13.73,9.61,13.73l1.94,0C257.94,334.67,257.28,328.33,257.28,325.11Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M262.58,284.44c3,3.29,9.33,1.65,9.33,2.75s-4.94,3.57-3,7.41,13.19,20.33,9.89,23.35c-.95.87-4,2-7.82,3.26,3.58,1.58,10.91,2.17,10.7-5.71-.25-9.11-8.62-41.62-10.84-44.82C270.82,270.68,259.55,281.14,262.58,284.44Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M254.58,288.29a5.66,5.66,0,0,0-1.69,5.94c1.13,3.67,5.37,7.35,4.24,9.33s-9.62.57-9.33,3.4,9.05,12.16,9.05,12.16l3.67-16.69Z"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M246.93,259.35s-3.2,11.33-7.14,25.62-3.2,58.6-3.2,61.07,5.66,11.32,12.07,13.79a51.89,51.89,0,0,0,13,2.95s-4.43-29.3-4.43-37.67,3.94-21.43,3.94-21.43,5.91,14.78,8.37,16.75,12.31,4.18,12.07-4.93-8.62-41.62-10.84-44.82-12.81-6.4-12.81-6.4Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.02 254.4 234.26 263.47 235.13 271.47 249.18 258.72 247.02 254.4",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.12,320.92s-9.36-4.19-10.1-4.19-8.12,3.94-9.6,3.94-2.22,1-1.23,1.73a5.34,5.34,0,0,0,2.71.74s-3.45,2-3.21,2.95,2.22,1.72,2.22,1.72a9.06,9.06,0,0,0,4.19,3.45c2.46.74,11.08-2.21,11.08-2.21l6.65-.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-11--inject-24)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241,321c-3,.67-9.09,6.81-9.09,6.81a9.06,9.06,0,0,0,4.19,3.45c2.46.74,11.08-2.21,11.08-2.21l6.65-.5-2.71-7.63S244,320.33,241,321Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241,321c-3,.67-9.09,6.81-9.09,6.81a9.06,9.06,0,0,0,4.19,3.45c2.46.74,11.08-2.21,11.08-2.21l6.65-.5-2.71-7.63S244,320.33,241,321Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M251.12,320.92s-9.36-4.19-10.1-4.19-8.12,3.94-9.6,3.94-2.22,1-1.23,1.73a5.34,5.34,0,0,0,2.71.74s-3.45,2-3.21,2.95,2.22,1.72,2.22,1.72a9.06,9.06,0,0,0,4.19,3.45c2.46.74,11.08-2.21,11.08-2.21l6.65-.5Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.53,310.33l-23.15,9.36,1.72,9.85s31-4.43,32.51-6.65-4.19-14.78-4.19-14.78",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-12--inject-24)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.57,326.51l.53,3s31-4.43,32.51-6.65-4.19-14.78-4.19-14.78l-3.31,1.07c1.91,4,3,7.52,1.67,8.77C276.3,320.22,259.65,324.52,251.57,326.51Z",
    style: {
      opacity: 0.26
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M273.53,310.33l-23.15,9.36,1.72,9.85s31-4.43,32.51-6.65-4.19-14.78-4.19-14.78",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.67,307s4.62-17.85,6.09-27.7",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "223.05 358.26 229.69 363.8 230.8 385.96",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.22,303.68l-6.54-12s-1.89-2.52,1.89-8.82",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.69,211.93c-10.52-1.42-16.2,5.68-14.5,8a3.25,3.25,0,0,0,1.82,1.37l1.31-.24s9.66.29,9.1,3.41-6.26,3.42-4,6a11.33,11.33,0,0,0,2,1.74l-.33,0a4.66,4.66,0,0,1,1.36,1.94c.39,1.17-1.75,10.89-2.14,11.67s-2.53-.2-5.25-2.14a10.93,10.93,0,0,0-4.86-2.14l-.19,1.75s2.72.78,3.11,2.33-2.14,1.75-2.14,3.12-.19,3.81,1.65,5.31,7.4-.86,7.4-.86,4.17-2.9,4.76-6c.47-2.54.82-7,1.25-9.22a17.68,17.68,0,0,0,1.66-2.39s4.55-1.14,3.13,3.41-4.27,4.55-4.27,4.55A27.29,27.29,0,0,0,247.06,247v-.07s8.53-9.66,9.1-17.34S246.21,213.35,235.69,211.93Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mug--inject-24"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 245.7,
    y: 355.82,
    width: 16.84,
    height: 24.88,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.79,377.32H260a1.39,1.39,0,0,1,0-2.78h1.76a2.63,2.63,0,0,0,2.63-2.63v-6a2.64,2.64,0,0,0-2.63-2.64h-2.26a1.39,1.39,0,1,1,0-2.77h2.26a5.41,5.41,0,0,1,5.41,5.41v6A5.42,5.42,0,0,1,261.79,377.32Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.28,380.37H127.52a.89.89,0,0,1-.82-.53L114,351a.89.89,0,0,1,.82-1.25h45.76a.88.88,0,0,1,.81.54l12.67,28.89A.88.88,0,0,1,173.28,380.37Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169,378.12H129.94a.76.76,0,0,1-.69-.45L118.44,353a.76.76,0,0,1,.69-1.07h39.05a.78.78,0,0,1,.7.46l10.81,24.65A.76.76,0,0,1,169,378.12Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.88,
    y: 378.45,
    width: 68.75,
    height: 2.25,
    transform: "translate(322.51 759.16) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.88,
    y: 378.45,
    width: 33.33,
    height: 2.25,
    transform: "translate(287.09 759.16) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.37,324.74a14.94,14.94,0,0,0,4.39.49s-.67-2-.73-2.16c-.68-1.43-2.85-3.8-4.61-3.56a2.1,2.1,0,0,0-1.68,2.64A4.38,4.38,0,0,0,64.37,324.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.44,333.77a14.65,14.65,0,0,0,4.33-.68,35.86,35.86,0,0,0,1.68,4.67c.38.89.8,1.77,1.22,2.64-.25-.37-.48-.7-.52-.74-1-1.2-3.74-2.91-5.38-2.21a2.1,2.1,0,0,0-.93,3,4.38,4.38,0,0,0,3.22,1.81,13.64,13.64,0,0,0,4.2-.64c.17.33.33.67.5,1,.81,1.61,1.62,3.2,2.36,4.8.27.56.51,1.12.75,1.68l-.45-.65c-1-1.2-3.75-2.9-5.39-2.21a2.11,2.11,0,0,0-.93,3A4.39,4.39,0,0,0,73.32,351a13.76,13.76,0,0,0,4.09-.61c.23.58.46,1.16.66,1.73.13.4.27.77.38,1.18l.33,1.18c.18.75.37,1.54.53,2.28.12.52.21,1,.32,1.51-.26-.56-.78-1.65-.84-1.73-.84-1.35-3.26-3.44-5-3a2.08,2.08,0,0,0-1.37,2.8,4.35,4.35,0,0,0,2.91,2.28,14.34,14.34,0,0,0,4.35,0c.16.83.32,1.63.45,2.39.46,2.64.75,4.85.93,6.4,0,.27.06.52.08.75H75.82l.65,12.64H88.18l.65-12.64h-5c0-.07.07-.15.11-.23.68-1.42,1.63-3.46,2.65-6,.33-.79.66-1.64,1-2.51a14.43,14.43,0,0,0,4.34.33A4.36,4.36,0,0,0,95,357.74a2.1,2.1,0,0,0-1.16-2.91c-1.68-.56-4.25,1.35-5.19,2.63-.06.07-.57,1-.88,1.52.13-.36.27-.71.4-1.08.27-.73.52-1.47.78-2.26l.36-1.18c.12-.39.2-.82.31-1.23.23-1,.42-1.94.58-2.94a14,14,0,0,0,4.12.95,4.44,4.44,0,0,0,3.35-1.57,2.1,2.1,0,0,0-.71-3.05c-1.58-.81-4.41.69-5.53,1.81-.07.07-.79,1-1.17,1.46.09-.6.19-1.2.27-1.81.21-1.76.38-3.55.55-5.33.06-.55.12-1.09.17-1.64a14.58,14.58,0,0,0,4.26,1,4.39,4.39,0,0,0,3.35-1.57,2.09,2.09,0,0,0-.71-3c-1.57-.82-4.4.68-5.53,1.8-.08.09-1.11,1.37-1.36,1.71.13-1.2.27-2.39.45-3.56a36.4,36.4,0,0,1,1-4.69,14.94,14.94,0,0,0,4.28,1,4.44,4.44,0,0,0,3.35-1.57,2.11,2.11,0,0,0-.71-3.05c-1.58-.81-4.41.69-5.53,1.81-.09.09-1.2,1.47-1.38,1.74a2.86,2.86,0,0,0,.07-.28A27.26,27.26,0,0,1,94.69,328c.4-.79.83-1.53,1.27-2.23a14.16,14.16,0,0,0,4.05,1.43,4.4,4.4,0,0,0,3.5-1.19,2.11,2.11,0,0,0-.36-3.11c-1.48-1-4.46.2-5.7,1.19-.07.05-.69.67-1.14,1.13.2-.31.4-.64.6-.94.74-1.12,1.49-2.09,2.16-2.95l1.08-1.33a13.88,13.88,0,0,0,4.24-.6,4.39,4.39,0,0,0,2.56-2.67,2.1,2.1,0,0,0-1.76-2.58c-1.77-.19-3.86,2.23-4.51,3.67-.05.13-.7,2.19-.67,2.19h0c-.34.38-.69.79-1.07,1.24-.69.85-1.46,1.82-2.23,2.92a37.92,37.92,0,0,0-2.31,3.69,27.36,27.36,0,0,0-2,4.45l0,.06c0-.52,0-2,0-2.09-.2-1.57-1.52-4.49-3.26-4.81a2.11,2.11,0,0,0-2.43,2,4.41,4.41,0,0,0,1.69,3.28,14.61,14.61,0,0,0,4,1.82,38.28,38.28,0,0,0-1.17,4.83c-.17.95-.31,1.91-.44,2.87,0-.45,0-.85,0-.9-.21-1.58-1.52-4.49-3.27-4.82a2.1,2.1,0,0,0-2.42,2,4.37,4.37,0,0,0,1.68,3.29,14.05,14.05,0,0,0,3.86,1.78c0,.37-.09.74-.13,1.11-.22,1.78-.42,3.56-.68,5.3-.09.61-.2,1.21-.3,1.81,0-.4,0-.73,0-.78-.2-1.58-1.52-4.49-3.26-4.82a2.11,2.11,0,0,0-2.43,2,4.42,4.42,0,0,0,1.69,3.29,13.43,13.43,0,0,0,3.75,1.74c-.13.61-.26,1.23-.41,1.82-.12.39-.2.79-.33,1.18s-.26.78-.38,1.17c-.27.73-.54,1.49-.82,2.2-.19.49-.38,1-.57,1.43.1-.61.26-1.81.27-1.91a8.19,8.19,0,0,0-1.1-4,1.78,1.78,0,0,0,0-.46,2.1,2.1,0,0,0-2.57-1.78c-1.71.45-2.8,3.47-2.88,5.05,0,.09,0,1.11.1,1.75-.08-.37-.16-.73-.26-1.12-.18-.75-.38-1.51-.59-2.32q-.18-.57-.36-1.17c-.11-.39-.27-.8-.41-1.2-.34-.93-.73-1.85-1.14-2.77a13.66,13.66,0,0,0,4-1.49,4.39,4.39,0,0,0,1.93-3.15,2.1,2.1,0,0,0-2.27-2.15c-1.76.19-3.29,3-3.61,4.56,0,.09-.13,1.23-.17,1.86-.26-.55-.51-1.1-.78-1.66-.79-1.58-1.64-3.17-2.48-4.75l-.76-1.46a14.25,14.25,0,0,0,4.11-1.52,4.38,4.38,0,0,0,1.92-3.15A2.09,2.09,0,0,0,77.32,334c-1.77.19-3.3,3-3.62,4.56,0,.11-.17,1.75-.19,2.17-.56-1.07-1.1-2.14-1.6-3.22a36.71,36.71,0,0,1-1.73-4.47,14.76,14.76,0,0,0,4.13-1.53,4.39,4.39,0,0,0,1.93-3.15A2.1,2.1,0,0,0,74,326.25c-1.77.19-3.3,3-3.62,4.56,0,.12-.18,1.88-.19,2.21l-.09-.27a27.66,27.66,0,0,1-.9-4.73c-.1-.88-.14-1.73-.17-2.55a14.23,14.23,0,0,0,4.17-1.05,4.4,4.4,0,0,0,2.26-2.92,2.1,2.1,0,0,0-2-2.39c-1.77,0-3.6,2.62-4.09,4.13,0,.08-.21.95-.33,1.58,0-.38,0-.76,0-1.12,0-1.34.09-2.57.18-3.66,0-.62.11-1.18.17-1.7a13.94,13.94,0,0,0,3.2-2.84,4.41,4.41,0,0,0,.66-3.63,2.1,2.1,0,0,0-2.89-1.19c-1.58.82-2,4-1.73,5.55,0,.14.61,2.21.64,2.19l0,0c-.07.5-.14,1-.2,1.63-.11,1.09-.22,2.32-.25,3.67a36,36,0,0,0,.1,4.35,27.32,27.32,0,0,0,.81,4.81l0,.05c-.28-.44-1.1-1.64-1.18-1.72-1-1.2-3.74-2.91-5.38-2.22a2.1,2.1,0,0,0-.93,3A4.38,4.38,0,0,0,65.44,333.77ZM83.05,357a15.12,15.12,0,0,0,3.54,2.28c-.32.78-.64,1.54-1,2.24-1.06,2.46-2,4.46-2.75,5.86-.14.28-.27.52-.39.75h-.12q0-.41-.12-.9c-.21-1.56-.55-3.79-1.08-6.44-.16-.84-.36-1.73-.56-2.65A23.21,23.21,0,0,0,83.05,357Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.89,325.43s.56-2.07.58-2.21c.22-1.57-.28-4.73-1.88-5.5A2.1,2.1,0,0,0,91.73,319a4.4,4.4,0,0,0,.76,3.62A14.85,14.85,0,0,0,95.89,325.43Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-24"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 68.33,
    y1: 380.71,
    x2: 441.67,
    y2: 380.71,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNlReports);
export default __webpack_public_path__ + "static/media/nl-reports.cf5567cbf5156b26040d240e8a212146.svg";
export { ForwardRef as ReactComponent };